import {HttpContextToken} from '@angular/common/http';

/**
 * Marks a request as a presigned S3 call: the auth interceptor must leave it
 * completely untouched (an Authorization header makes S3 reject the request).
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
